import { Phone, Ticket, Accessibility, ShieldAlert } from "lucide-react";

const iconMap = {
  ticket_office: Ticket,
  ada_office: Accessibility,
  emergency: ShieldAlert,
};

export const ContactCard = ({ contact }) => {
  const Icon = iconMap[contact.type] || Phone;

  const handleCall = () => {
    window.location.href = `tel:${contact.phone}`;
  };

  return (
    <button
      className="contact-card w-full touch-target"
      onClick={handleCall}
      aria-label={`Call ${contact.name} at ${contact.phone}`}
      data-testid={`contact-${contact.type}`}
    >
      <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0">
        <Icon size={24} className="text-primary" />
      </div>
      
      <div className="flex-1 text-left">
        <h3
          className="font-semibold text-base"
          style={{ fontFamily: "Lexend, sans-serif" }}
        >
          {contact.name}
        </h3>
        <p className="text-sm text-muted-foreground">{contact.phone}</p>
        <p className="text-xs text-muted-foreground mt-1">{contact.description}</p>
      </div>
      
      <div className="w-10 h-10 rounded-full bg-green-100 flex items-center justify-center flex-shrink-0">
        <Phone size={20} className="text-green-600" />
      </div>
    </button>
  );
};
